import { Button, Dialog, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { RootState } from "../../../../app/store";
import AppTextField from "../../../../app/components/app-textfield";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { addExternalSitatuationThunk, showAddFormExternalSituationAct, updateExternalSituationThunk, updateInputExternalSituationAct } from "../external-situations.slice";

export default function ExternalSituationForm() {
  const {showForm, situationForm, situationForEditId} = useAppSelector((state:RootState) => state.externalSituations);
  const dispatch = useAppDispatch()
  const submitForm = (e: any) => {  
    e.preventDefault()
    if(situationForEditId !== ''){
      dispatch(updateExternalSituationThunk({data: situationForm, situationId: situationForEditId}))
    } else {
      dispatch(addExternalSitatuationThunk({data: situationForm}))
    }
  }
  const changeInput = ({name, val} : {name: string, val: any}) => {
    dispatch(updateInputExternalSituationAct({key: name, value: val}))
  }
  return(
    <Dialog open={showForm} onClose={() => dispatch(showAddFormExternalSituationAct(false))}>
    <DialogTitle> External Situation </DialogTitle>
      <DialogContent sx={{minWidth: "550px"}}>
        <form onSubmit={submitForm}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <AppTextField type={"number"} name="order" label="Position" value={situationForm.order} onChange={changeInput}/>
            </Grid>
            <Grid item xs={12}>
              <AppTextField label="Spanish title" name="title" value={situationForm.title} onChange={changeInput}/>
            </Grid>
            <Grid item xs={12}>
              <AppTextField label="English Titler" name="titleEn" value={situationForm.titleEn} onChange={changeInput}/>
            </Grid>
            <Grid item xs={12} minHeight={"300px"}>
              <ReactQuill style={{height: "85%"}}  theme="snow" value={situationForm.description ?? ""} onChange={(value, delta, source, editor) => {
                changeInput({name: "description", val: value})
              }} />
            </Grid>
            <Grid item xs={12} minHeight={"300px"}>
              <ReactQuill style={{height: "85%"}}  theme="snow" value={situationForm.descriptionEn ?? ""} onChange={(value, delta, source, editor) => {
                changeInput({name: "descriptionEn", val: value})
              }} />
            </Grid>
            <Grid item xs={4}> <Button type="submit" variant="contained"> GUARDAR </Button> </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  )
}